import { ShieldAlert } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { clearSessionToken, apiFetch } from '../fetchInterceptor';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const ImpersonationBanner = () => {
  const { user } = useAuth();
  if (!user?.impersonation) return null;

  const exitImpersonation = async () => {
    try {
      await apiFetch(`${API_URL}/api/auth/impersonation/end`, { method: 'POST' });
    } catch { /* best effort */ }
    clearSessionToken();
    window.location.href = '/owner-admin';
  };

  return (
    <div
      data-testid="impersonation-banner"
      className="fixed bottom-0 inset-x-0 z-[100] bg-amber-500 text-black px-4 py-2 flex items-center justify-center gap-3 text-sm font-medium shadow-[0_-4px_16px_rgba(0,0,0,0.3)]"
    >
      <ShieldAlert size={16} className="shrink-0" />
      <span className="truncate">
        Viewing as <strong>{user.name}</strong> ({user.email}) — Admin session
      </span>
      <button
        onClick={exitImpersonation}
        data-testid="impersonation-exit-btn"
        className="ml-2 px-3 py-1 rounded-full bg-black text-amber-400 text-xs font-semibold hover:bg-black/80 transition-colors"
      >
        Exit
      </button>
    </div>
  );
};
